<template>
  <div class="text-center">
    <b-spinner variant="primary" label="Loading..."></b-spinner>
  </div>
</template>

<script>
/*
This component listens for specific event emissions
in order to show & hide the global loading dialog.
*/
export default {
  data () {
    return {
      isLoading: false
    }
  },
  mounted () {
    this.EventHolder.$on('startLoading', () => {
      this.isLoading = true
    })
    this.EventHolder.$on('stopLoading', () => {
      this.isLoading = false
    })
  }
}
</script>

<style>
</style>
